<main>
    <div class="loginWraper">
        <div class="title">
            <h2>તમારો મોબાઈલ નંબર ચકાસવા માટે કૃપા કરીને OTP દાખલ કરો.</h2>
        </div>
        <form >
            <div class="form-group">
                <div class="input-grp">
                    <input type="text" class="form-control" value="1"/>
                    <input type="text" class="form-control" value="1" />
                    <input type="text" class="form-control" value="1" />
                    <input type="text" class="form-control" value="1" />
                </div>
                <button type="submit" class="btn-common" (click)="submit()">સાચવો </button>
            </div>
        </form>
    </div>
</main>